import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requirePermission } from '~/utils/guards';

const SubsidiariesPage = lazy(() => import('~/features/organization/pages/subsidiaries-page'));

export const Route = createFileRoute('/_authenticated/_tenant/subsidiary/subsidiaries')({
  beforeLoad: requirePermission('organization_subsidiaries'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <SubsidiariesPage />
    </Suspense>
  ),
});
